import { defineBlock, EditableText, InnerBlocks, useInlineEditableValue, usePostTitleEditor } from "eddev/blocks"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { twMerge } from "tailwind-merge"
import dayjs from "dayjs"
import { Button } from "@components/ui/Button"
import { GridBreakout } from "@components/site/GridBreakout"
import { cn } from "@utils/tw"
import { Link } from "eddev/routing"
import { IconChevronLeft } from "@components/ui/Icon"

export const meta: BlockMeta = {
  title: "News Header",
  inserter: false,
  postMetaBlock: {
    postTypes: ["news"],
    fieldName: "newsHeader",
  },
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("news/header-single", (props) => {
  return (
    <>
      <div className="w-full flex flex-col mb-5">
        <div className={twMerge("grid-auto")}>
          <div
            className={twMerge("col-span-12 md:col-span-6 md:col-start-4 flex flex-col gap-5", "mt-pageHeaderBasicMT")}
          >
            <Link href="/news" className="type-label-xs flex items-center gap-1 justify-center w-fit mb-4 -mt-4">
              <IconChevronLeft className="w-[1.2em] h-[1.2em]" />
              <span className="mt-[0.2em] hover-link">All News</span>
            </Link>
            <div className="type-title-xxl w-full">
              {env.admin ? (
                <EditableText store={usePostTitleEditor()} as="span" placeholder="Enter title" plainText />
              ) : (
                props.news?.title
              )}
            </div>
            <div className="w-full gap-3 flex">
              <Button size="sm" variant="secondary" className="pointer-events-none">
                {dayjs(props.news?.date).format("MMMM DD, YYYY")}
              </Button>
              {props.author?.map((author) => (
                <Button key={author?.name} size="sm" variant="secondary">
                  {author?.name}
                </Button>
              ))}
              {props.category && (
                <Button
                  key={props.category.uri}
                  href={`/news/?category=${props.category.slug}`}
                  size="sm"
                  variant="secondary"
                >
                  {props.category.name}
                </Button>
              )}
              {props.tags?.map((tag) => (
                <Button key={tag?.uri} href={`/news/?tag[]=${tag?.slug}`} size="sm" variant="secondary">
                  {tag?.name}
                </Button>
              ))}
            </div>

            <GridBreakout amount={1} className={cn("block-image w-full flex flex-col gap-4 mt-5 mb-5")}>
              <div className="w-full">
                {props.featuredImage ? (
                  <ResponsiveImage
                    {...props.featuredImage}
                    className="w-full h-full"
                    objectFit="contain"
                    objectPosition="center"
                  />
                ) : (
                  env.admin && (
                    <div className="w-full h-0 pt-[60%] bg-grey1 border border-dashed border-black relative">
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        Featured Image
                      </div>
                    </div>
                  )
                )}
              </div>
            </GridBreakout>
          </div>
        </div>
      </div>
    </>
  )
})
